import React from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "../home/SectionTitle";

import transactionImg from "../../img/security/transaction.webp";

const ITEMS = [
  "securityPage.transaction.item1",
  "securityPage.transaction.item2",
  "securityPage.transaction.item3",
  "securityPage.transaction.item4",
];

function Transaction() {
  const { t } = useTranslation();

  return (
    <section className="mt-[80px] xl:mt-0">
      <div className="glcontainer">
        {/* Mobile: фото над текстом */}
        <div className="lg:hidden mb-[20px] h-[173px] overflow-hidden">
          <img
            src={transactionImg}
            alt=""
            aria-hidden
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex flex-col lg:flex-row gap-[25px] lg:gap-[77px] items-start">
          {/* Фото слева (desktop) */}
          <Fade triggerOnce direction="left" duration={700} className="hidden lg:block w-[50%] shrink-0">
          <div className="aspect-[610/552] overflow-hidden">
            <img
              src={transactionImg}
              alt=""
              aria-hidden
              className="w-full h-full object-cover"
            />
          </div>
          </Fade>

          {/* Контент справа */}
          <div className="flex flex-col flex-1 w-full lg:pt-[99px]">
            <SectionTitle
              title1={t("securityPage.transaction.title1")}
              title2={t("securityPage.transaction.title2")}
              text={t("securityPage.transaction.subtitle")}
              align="left"
              className="max-w-[525px] [&>p]:max-w-none"
            />

            <ul className="mt-[15px] flex flex-col gap-[12px] lg:gap-[15px] max-w-[525px]">
              <Fade cascade triggerOnce direction="up" damping={0.06}>
                {ITEMS.map((key) => (
                  <li
                    key={key}
                    className="font-['Inter'] font-normal text-[14px] lg:text-[16px] leading-[1.5] text-[#435c7f] list-disc ml-[20px] lg:ml-[24px]"
                  >
                    {t(key)}
                  </li>
                ))}
              </Fade>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Transaction;
